import { connect } from "react-redux";
import NotComparedTable from "./NotComparedTable";
import { getProjectComparison } from "../../../../../../../../../../redux/actions";
import { selectTrendTotals } from "../../../../utils/selectTrendTotals";

const mapStateToProps = (state) => ({
    benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis,
    fetchProjectNotComparedApi: state.BenchmarkFilteringReducer.fetchProjectNotComparedApi,
    // This list's own size, then the same denominator the Compared badge quotes.
    listTotal: selectTrendTotals(state).notComparedListTotal,
    totalCount: selectTrendTotals(state).totalCount,
});

const mapDispatchToProps = (dispatch) => ({
    getProjectComparison: (payload) => dispatch(getProjectComparison(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotComparedTable);
